import {
  AppBar,
  Box,
  Grid,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import Navigate from "../../Pages/Navigate/Navigate";
import { Link, useNavigate } from "react-router-dom";
import ShopbyCategory from "./ShopbyCategory";
import HeaderMenulist from "./HeaderMenulist";
import Headernewcentre from "./Headernewcentre";
import logo from "../../Assets/logo.svg";
import { useLogin } from "../../client-api/LoginRegister";
import { useAuthContext } from "../../Context/AuthContext";
import { usePoPupContext } from "../../Context/PopupContext";
import { useDispatch, useSelector } from "react-redux";

const Navbar = () => {
  function refreshPage() {
    window.location.href = "/";
  }
  const theme = useTheme();

  const { login, isLoading, error } = useLogin();
  const { user, getuserdata } = useAuthContext();

  const { setopenpopup } = usePoPupContext();

  const [search, setsearch] = useState(false);
  const [cat, setCat] = useState([]);
  const navgate = useNavigate();
  const dispatch = useDispatch();
  const { cart_items, cartCount } = useSelector((state) => state.cartUi);
  // const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  const isMatch = useMediaQuery(theme.breakpoints.down(1300));

  return (
    <React.Fragment>
      <AppBar
        // sx={{ maxHeight: "130px" }}
        sx={{ paddingBottom: "10px", backgroundColor: "#fff" }}
      >
        <Toolbar
          variant="dense"
          sx={{
            gap: 2,
            px: "0!important",
            backgroundColor: "#f5f5f5",
            // alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
              // ml: "auto",
              alignItems: "center",
              px: 5,
              width: "100%",
              justifyContent: { xs: "center", md: "space-between" },
            }}
          >
            <Box sx={{ pt: 2, display: { xs: "none", md: "block" } }}>
              <p style={{ color: "#999999" }}>
                Free standard shipping for orders{" "}
                <span style={{ color: "#000" }}>
                  <b>over 200 AED </b>{" "}
                </span>
                .
              </p>
            </Box>

            <Box sx={{ display: "flex", gap: 3 }}>
              <Link to="/brands" className="brands_hd">
                <p className="Heading_main2">Brands</p>
              </Link>

              <Link to="/offers" className="brands_hd">
                <span className="Heading_main2">Offer Zone</span>
              </Link>

              <Link to="/blogs/news" className="brands_hd">
                <span className="Heading_main2">Blogs</span>
              </Link>
            </Box>
          </Box>
        </Toolbar>

        <Headernewcentre />

        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#fff",
            width: "100%",
            margin: "auto",
            height: "50px",
            minHeight: "50px!important",
            // maxWidth:{lg:'1300px', md:'1300px', sm:'100%', xs:'100%'}
            paddingLeft: { lg: "3%", md: "3%", sm: "3%", xs: "3%" },
            paddingRight: { lg: "3%", md: "3%", sm: "3%", xs: "3%" },
            marginTop: "5px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#1C2127",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                height: "100%",
                gap: "30px",
                width: { xs: "100%", md: "auto" },
              }}
            >
              <ShopbyCategory />
              <Box
                sx={{
                  display: { xs: "none", md: "flex", lg: "flex" },
                  gap: 3,
                  marginTop: "13px",
                  marginBottom: "auto",
                }}
              >
                {!isMatch && <HeaderMenulist />}
              </Box>
            </Box>

            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                gap: 1,
                pr: 2,
              }}
            >
              <i className="fa fa-light fa-phone" />
              <Typography sx={{ color: "white" }}>
                Ask our experts:{" "}
                <Box
                  component="span"
                  sx={{ color: "#FFA500", fontWeight: "bold" }}
                >
                  +971564127900
                </Box>
              </Typography>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <div style={{ marginTop: "186px" }}>
        <Navigate />
      </div>
    </React.Fragment>
  );
};

export default Navbar;
